
const getFloorElementsByType = (floorData, type) => {
    return floorData.floorElements.filter(e => e.type === type && e.floorId === floorData.activeFloor);
}

export {
    getFloorElementsByType
}